import { onCLS, onFCP, onLCP, onTTFB, onINP, Metric } from "web-vitals";

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void): void => {
  if (onPerfEntry && typeof onPerfEntry === "function") {
    onCLS(onPerfEntry);

    onINP(onPerfEntry);

    onFCP(onPerfEntry);

    onLCP(onPerfEntry);

    onTTFB(onPerfEntry);
  }
};

export default reportWebVitals;
